var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 365.4 365.4",
    style: {
      enableBackground: "new 0 0 365.4 365.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8037,
    y1: 182.721,
    x2: 314.641,
    y2: 182.721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1245C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9909B7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213,274.1h-68.5c-3,0-5.7,1.1-8,3.4c-2.3,2.3-3.4,4.9-3.4,8V354c0,3,1.1,5.7,3.4,8c2.3,2.3,4.9,3.4,8,3.4H213 c3,0,5.7-1.1,8-3.4c2.3-2.3,3.4-4.9,3.4-8v-68.5c0-3-1.1-5.7-3.4-8C218.7,275.2,216,274.1,213,274.1z M302.9,69 c-7.8-14.4-17.9-26.5-30.3-36.4c-12.4-9.9-26.3-17.8-41.7-23.7C215.6,3,200.2,0,185,0C127.2,0,83,25.3,52.5,75.9 c-1.5,2.5-2,5.1-1.6,8c0.5,2.9,2,5.2,4.4,7.1l46.8,35.7c2.5,1.5,4.9,2.3,7.1,2.3c3.4,0,6.4-1.5,8.9-4.6 c13.7-17.1,23.9-28.1,30.5-32.8c8.2-5.5,18.5-8.3,30.8-8.3c11.6,0,21.8,3,30.7,9.1c8.9,6.1,13.3,13.1,13.3,21.1 c0,8.9-2.4,16.2-7.1,21.7c-4.8,5.5-12.8,10.8-24,16c-14.8,6.7-28.5,17-40.8,31c-12.4,14-18.6,28.9-18.6,44.7v12.8 c0,3.6,1,7.2,3,10.7c2,3.5,4.4,5.3,7.3,5.3h68.5c3,0,5.7-1.5,8-4.4c2.3-2.9,3.4-6,3.4-9.3c0-4.8,2.6-11.1,7.8-19.1 c5.2-8,11.8-14.2,19.6-18.6c7.4-4.2,13.2-7.6,17.4-10.1c4.2-2.6,9.7-6.7,16.4-12.4c6.8-5.7,12-11.4,15.7-17c3.7-5.6,7-12.9,10-21.8 c3-8.9,4.4-18.6,4.4-28.8C314.6,98.4,310.7,83.3,302.9,69z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question_mark_icon.b583019398e63e189c13d87864d4477a.svg";
export { ForwardRef as ReactComponent };